import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-custom-help-component',
  templateUrl: './custom-help.component.html',
  styleUrls: ['./custom-help.component.scss'],
  standalone: false
})
export class CustomHelpComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
